const units = {
  toast: {
    error: {
      badResponse: '[אתרים] תגובת שרת שגויה',
      create: {},
      edit: {},
    },
    success: {
      create: { default: 'האתר נוצר בהצלחה' },
      edit: {},
      delete: {
        default: 'אתרים נמחקו בהצלחה',
      },
    },
  },
  headerButtons: {
    create: 'הוסף',
    delete: {
      label: 'מחק',
      deleteModal: {
        header: 'מחק אתרים',
        body: 'אתה עומד למחוק {{units}} אתרים',
      },
    },
  },

  create: {
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן ליצור אתר',
    },
    duplicateToast: {
      message: 'אתר בשם זה כבר קיים',
    },
    successToast: {
      message: 'הצלחה! האתר נוסף בהצלחה',
    },
  },

  edit: {
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן לעדכן אתר',
    },
    successToast: {
      message: 'הצלחה! האתר עודכן בהצלחה',
    },
  },

  delete: {
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן למחוק אתר',
    },
    successToast: {
      message: 'הצלחה! האתר נמחק בהצלחה',
    },
    deleteViewSite: {
      message: 'אתר תצוגה לא ניתן למחוק',
    },
  },

  form: {
    header: {
      create: {
        title: 'הוסף',
      },

      update: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    information: {
      details: {
        header: 'פרטים',
        fields: {
          name: 'שם',
        },
      },

      information: {
        header: 'מידע',
        fields: {
          operation: {
            title: 'פעילות',
            options: {
              default: 'ברירת מחדל',
              school: 'בית ספר',
              NEMT: 'תחבורה רפואית לא דחופה',
              microtransit: 'מיקרו-תחבורה',
              airportShuttle: 'שאטל לשדה תעופה',
              employee: 'עובדים',
              deliveries: 'משלוחים',
              evs: 'רכבים חשמליים',
              broker: 'ברוקר',
            },
          },
          schoolOperationsEnabled: {
            title: 'אפשר בית ספר',
          },
          employeeOperationsEnabled: {
            title: 'אפשר מקום עבודה'
          },
        },
      },
      contactUsInformation: {
        header: 'פרטי יצירת קשר לאפליקציה לנייד',
        fields: {
          address: 'כתובת',
          phone: 'טלפון',
          email: 'אימייל',
        },
      }
    },
    valdations: {
      name: {
        required: 'שם נדרש',
        name: 'שם לא חוקי',
      },
    },
  },
  table: {
    headers: {
      name: 'שם',
      operation: 'פעילות',
    },
    actions: {
      delete: 'מחק',
      export: 'ייצא',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
};

export default units;
